import React, { useState, useEffect } from "react";
import referLogo from "../../assets/images/refer/refer-earn.png";
import { useSelector, useDispatch } from "react-redux";
import icons from "../../assets/images/sprite-other-icons.svg";
import ReferalBonus from "../Loyalty/ReferalBonus";
import LoyaltyConfig from "../../assets/loyaltyPointsConfig.json";
import { fetchBanners } from "../banners/cl_Banners";

const Refer = () => {
  const [copiedText, setCopiedText] = useState("Copy");
  const [showCopiedText, setShowCopiedText] = useState(false);
  const [isMobileApp, setIsMobileApp] = useState(false);
  const dispatch = useDispatch();
  const { superBannersData } = useSelector((state) => state.banners);
  const { userDetails, userLoyalty } = useSelector((state) => state.signIn);

  useEffect(() => {
    dispatch(fetchBanners());

    const checkMobileApp = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      const isMedianApp =
        userAgent.includes("median") || userAgent.includes("wkwebview");

      const isMobile =
        /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
          userAgent
        );
      const isStandalone =
        window.navigator.standalone ||
        window.matchMedia("(display-mode: standalone)").matches;

      const isApp =
        window.ReactNativeWebView ||
        window.webkit?.messageHandlers ||
        isMedianApp;

      return isApp || (isMobile || isStandalone);
    };

    setIsMobileApp(checkMobileApp());
  }, [dispatch]);

  const referralBanner = Array.isArray(superBannersData)
    ? superBannersData.find(
        (banner) => banner.master_typeid === 14 && banner.is_active
      )
    : null;
  const invitationCode = userDetails?.userRefCode;
  const referralLink =
    process.env.REACT_APP_FASFASREFERURL + `/signup/?refid=${invitationCode}`;

  const onShare = () => {
    navigator.clipboard.writeText(referralLink);
    setCopiedText("Copied");
    setTimeout(() => {
      setCopiedText("Copy");
    }, 3000);
  };

  const shareData = {
    title: "FasFas - Referal",
    text: "Refer and Earn",
    url: referralLink,
  };

  const handleShare = async () => {
    if (isMobileApp) {
      navigator.clipboard.writeText(referralLink);
      document.querySelector(".SB-btnreferNow").textContent = "Copied!";
      setTimeout(() => {
        document.querySelector(".SB-btnreferNow").textContent = "Copy to Refer";
      }, 2000);
    } else {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        onShare();
      }
    }
  };

  return (
    <div className="SB-page-content">
      <div className="SB-myAccountSection-container SB-referAndEarn">
        <div className="SB-pageHeader">
          <div className="SB-pageHeader-title">Refer &amp; Earn</div>
        </div>
        <div className="SB-content">
          <div className="SB-referAndEarn-container">
            <div className="SB-referAndEarn-content">
              <div className="SB-referAndEarn-image">
                <img
                  src={referralBanner?.imagepath || referLogo}
                  alt="refer-earn"
                />
              </div>
              <div className="SB-referAndEarn-code-container">
                <div className="SB-label">
                  Invite all your friends to FasFas Games
                </div>
                <div className="SB-form-group">
                  <div className="SB-form-control-group SB-referAndEarnCode">
                    <div className="SB-form-control">
                      <input type="text" readOnly="" value={invitationCode} />
                    </div>
                    <div
                      className="SB-form-addon SB-addon-right"
                      role="button"
                      onClick={onShare}
                    >
                      {copiedText}
                    </div>
                  </div>
                  <div className="SB-referal-copied-success d-none">
                    <span>Referral Code copied successfully</span>
                  </div>
                </div>
              </div>
              <div className="SB-socialShareButtons SB-hide-mobile SB-show-desktop">
                <ul>
                  <li>
                    <a
                      href={
                        " https://www.facebook.com/profile.php?id=61559892426530"
                      }
                      className="SB-social-linkItem"
                    >
                      <div className="SB-iconSVG " title="Facebook">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="#FFF"
                        >
                          <use xlinkHref={`${icons}#${"icon-facebook"}`} />
                        </svg>
                      </div>
                    </a>
                  </li>

                  <li>
                    <a
                      href={"https://x.com/FasFasGame254"}
                      className="SB-social-linkItem"
                    >
                      <div className="SB-iconSVG " title="Twitter">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="#FFF"
                        >
                          <use xlinkHref={`${icons}#${"icon-twitter"}`} />
                        </svg>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a
                      href={
                        "https://www.youtube.com/channel/UCyE2a57Lebj47xWBB1xN22Q"
                      }
                      className="SB-social-linkItem"
                    >
                      <div className="SB-iconSVG " title="youtube">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="#FFF"
                        >
                          <use xlinkHref={`${icons}#${"icon-youtube"}`} />
                        </svg>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="SB-btnContainer">
                <button
                  className="btn SB-btnSecondary active SB-btnreferNow"
                  onClick={handleShare}
                >
                  {isMobileApp ? "Copy to Refer" : "Refer Now"}
                </button>
              </div>
            </div>
          </div>
          <div className="SB-myAccount-sectionBox SB-referAndEarn-earning"></div>
          <ReferalBonus showTable={"no"} />

          <div className="SB-myAccount-sectionBox SB-referral-benefits">
            <div className="SB-myAccount-sectionBox_header">
              Referral Benefits for your Loyalty Level
            </div>
            <div className="SB-userLevel-table SB-table-scrollable">
              <table>
                <colgroup>
                  <col />
                  <col
                    className={
                      userLoyalty?.lifeTimeCoins <=
                      LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[0]
                        .levelCutoff
                        ? "active"
                        : ""
                    }
                  />
                  <col
                    className={
                      userLoyalty?.lifeTimeCoins <=
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1]
                          .levelCutoff &&
                      userLoyalty?.lifeTimeCoins >=
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[0]
                          .levelCutoff
                        ? "active"
                        : ""
                    }
                  />
                  <col
                    className={
                      userLoyalty?.lifeTimeCoins <=
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2]
                          .levelCutoff &&
                      userLoyalty?.lifeTimeCoins >=
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[1]
                          .levelCutoff
                        ? "active"
                        : ""
                    }
                  />
                  <col
                    className={
                      userLoyalty?.lifeTimeCoins <=
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[4]
                          .levelEntry &&
                      userLoyalty?.lifeTimeCoins >=
                        LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[2]
                          .levelCutoff
                        ? "active"
                        : ""
                    }
                  />
                  <col
                    className={
                      userLoyalty?.lifeTimeCoins >=
                      LoyaltyConfig.loyaltyPointsConfig[1].loyaltyLevels[4]
                        .levelEntry
                        ? "active"
                        : ""
                    }
                  />
                </colgroup>
                <thead>
                  <tr>
                    <td></td>
                    <td>
                      <img
                        src={require("../../assets/images/loyalty/dash.webp")}
                        alt="dash"
                      />{" "}
                    </td>
                    <td>
                      <img
                        src={require("../../assets/images/loyalty/sprint.webp")}
                        alt="sprint"
                      />
                    </td>
                    <td>
                      <img
                        src={require("../../assets/images/loyalty/surge.webp")}
                        alt="surge"
                      />
                    </td>
                    <td>
                      <img
                        src={require("../../assets/images/loyalty/thrill.webp")}
                        alt="thrill"
                      />
                    </td>
                    {/* <td>
                                                 <img src={vip}  alt='boss' />
                                                 </td> */}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Friend's Signup</td>
                    <td>100</td>
                    <td>100</td>
                    <td>200</td>
                    <td>250</td>
                    {/* <td>
                                                      500
                                                    </td> */}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Refer;